import { render } from "./print-stock-adjustment.vue?vue&type=template&id=a46d2aa6&scoped=true"
import script from "./print-stock-adjustment.vue?vue&type=script&lang=js"
export * from "./print-stock-adjustment.vue?vue&type=script&lang=js"

import "./print-stock-adjustment.vue?vue&type=style&index=0&id=a46d2aa6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a46d2aa6"]])

export default __exports__